import { render, staticRenderFns } from "./ProjectBaseInformationForm.vue?vue&type=template&id=6853e4c0&"
import script from "./ProjectBaseInformationForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectBaseInformationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports